import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";

export function RLRoyaltyPanel() {
	var directive: ng.IDirective = {
		template: require("/assets/app/templates/royalty-panel.html"),
		restrict: "A",
		scope: {
			royaltySetId: "=",
			incomeGroups: "=",
			payees: "=",
			royaltySplits: "=",
			editMode: "="
		},
		controller: RLRoyaltyPanelController,
		controllerAs: "rpVM",
		link: (scope: IRLRoyaltyPanelScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {
		}
	};
	return directive;
}

interface IRLRoyaltyPanelScope extends ng.IScope {
	royaltySetId: string;
	royaltySplits: Models.IRoyaltySplit[];
	payees: Models.IEntity[];
	incomeGroups: Models.ICharacteristicMetaDataValue[];
	editMode: boolean;
}

class RLRoyaltyPanelController {
	static $inject = ["$scope", "$rootScope"];

	selectedIncomeGroups: Models.ICharacteristicMetaDataValue[];
	incomeGroupList: Models.ICharacteristicMetaDataValue[];
	incomeGroupColumnCount: number;

	selectedAboveLinePayees: Models.IEntity[];
	aboveLinePayeeList: Models.IEntity[];
	selectedBelowLinePayees: Models.IEntity[];
	belowLinePayeeList: Models.IEntity[];

	cellValues: _.Dictionary<_.Dictionary<number>>;

	cellTotals: number[];

	constructor(private $scope: IRLRoyaltyPanelScope, private $rootScope: ng.IRootScopeService) {
		this.selectedIncomeGroups = [];
		this.incomeGroupList = [];
		this.incomeGroupColumnCount = 1;

		this.selectedAboveLinePayees = [];
		this.aboveLinePayeeList = [];
		this.selectedBelowLinePayees = [];
		this.belowLinePayeeList = [];
		this.cellValues = {};
		this.cellTotals = [];

		// react to changes in scope payees, then remove any above/below selected if not present in new payee list.
		$scope.$watch(() => $scope.payees, (newValue, oldValue) => {
			if (newValue != oldValue) {
				this.selectedAboveLinePayees = _.filter(this.selectedAboveLinePayees, (payee) => _.any($scope.payees, (payee2) => payee.recordID == payee2.recordID));
				this.selectedBelowLinePayees = _.filter(this.selectedBelowLinePayees, (payee) => _.any($scope.payees, (payee2) => payee.recordID == payee2.recordID));
			}
		}, true);

		// react to changes in scope payees, selected above/below payees, then update the available payee list for above/below
		$scope.$watchCollection(() => [$scope.payees],
			(newValue, oldValue) => {
				var aboveList: Models.IEntity[] = [];
				var belowList: Models.IEntity[] = [];

				_.forEach($scope.payees, (payee) => {
					aboveList.push(payee);
					belowList.push(payee);
				});

				this.aboveLinePayeeList = aboveList;
				this.belowLinePayeeList = belowList;
			});


		// react to a change in income groups or selected income groups, set default values for new column
		$scope.$watch(() => [$scope.incomeGroups, this.selectedIncomeGroups],
			(newValue, oldValue) => {
				if (newValue[0]) {
					this.incomeGroupColumnCount = Math.ceil($scope.incomeGroups.length / 10);
					this.incomeGroupList = $scope.incomeGroups.filter((group) => group.characteristicValueID > 0);

					var lastIncomeGroup: Models.ICharacteristicMetaDataValue = null;
					_.forEach(this.selectedIncomeGroups, (group) => {
						// new income group just added
						if (this.cellValues[group.characteristicValueID] == null) {
							this.cellValues[group.characteristicValueID] = {};
							// set initial values
							if (lastIncomeGroup != null) {
								// copy splits from last column
								//concatenate 1 to front of recordID to denote above the line
								this.selectedAboveLinePayees.map((payee) => this.cellValues[group.characteristicValueID]["" + 1 + payee.recordID] = this.cellValues[lastIncomeGroup.characteristicValueID]["" + 1 + payee.recordID]);
								this.selectedBelowLinePayees.map((payee) => this.cellValues[group.characteristicValueID][payee.recordID] = this.cellValues[lastIncomeGroup.characteristicValueID][payee.recordID]);
							} else {
								// else split 100% evenly
								var payeeCount = (this.selectedAboveLinePayees.length + this.selectedBelowLinePayees.length) || 1;
								var avgSplit = (100 / payeeCount);
								this.selectedAboveLinePayees.map((payee) => this.cellValues[group.characteristicValueID]["" + 1 + payee.recordID] = avgSplit);
								this.selectedBelowLinePayees.map((payee) => this.cellValues[group.characteristicValueID][payee.recordID] = avgSplit);
							}
						}
						lastIncomeGroup = group;
					});
				}
			}, true);

		$scope.$on(Consts.Events.IncomeGroupsChanged, (event, royaltySetID: string, selectedIncomeGroups: number[]) => {
			if ($scope.royaltySetId == royaltySetID) {
				//check for any removed selected income groups
				var saveChanges = false;
				var removedIncomeGroups = _.remove(this.selectedIncomeGroups, (ig) => !_.any(selectedIncomeGroups, ig2 => ig2 == ig.characteristicValueID))

				if (removedIncomeGroups.length > 0) {
					this.UpdateSplits();
					this.$rootScope.$broadcast(Consts.Events.RoyaltySplitsChanged, royaltySetID, removedIncomeGroups);
				}
			}
		});

		// react to changes in selected incomegroups, above/below payees, clean up stray cells that don't match new selection state
		$scope.$watch(() => [this.selectedIncomeGroups, this.selectedAboveLinePayees, this.selectedBelowLinePayees],
			(newValue, oldValue) => {
				if (newValue != oldValue) {
					var incomeGroups = <Models.ICharacteristicMetaDataValue[]>newValue[0];
					var aboveLinePayees = <Models.IEntity[]>newValue[1];
					var belowLinePayees = <Models.IEntity[]>newValue[2];

					for (var rowKey in this.cellValues) {
						var incomeGroupID = _.parseInt(rowKey);
						if (!_.any(incomeGroups, (group) => group.characteristicValueID == incomeGroupID)) {
							delete this.cellValues[rowKey];
							continue;
						}

						var cols = this.cellValues[rowKey];
						for (var colKey in cols) {
							//concatenate 1 to front of above the line payees - mvca-3283
							if (!_.isUndefined(colKey) && !_.any(aboveLinePayees, (payee) => ("" + 1 + payee.recordID) == colKey.toString()) && !_.any(belowLinePayees, (payee) => payee.recordID.toString() == colKey)) {
								delete this.cellValues[rowKey][colKey];
							}
						}
					}
				}
			}, true);

		// since this is a 2-d sparse array with LARGE key values, 
		// we need to use simpler methods to hash the cells
		var cellValueHash = () => {
			var output: number[] = [];
			for (var rowKey in this.cellValues) {
				var cols = this.cellValues[rowKey];
				for (var colKey in cols) {
					output.push(cols[colKey]);
				}
			}
			return output;
		};

		// update totals and splits whenever cellValueHash changes
		$scope.$watch(() => cellValueHash(), (newValue, oldValue) => {
			if (newValue != oldValue) {
				this.CalcTotals();
				this.UpdateSplits();
			}
		}, true);

		$scope.$watchCollection(() => [this.$scope.incomeGroups, this.$scope.royaltySplits, this.$scope.payees],
			(newValue, oldValue) => {
				if (!this.$scope.editMode) {
					this.SetupGrid();
				}
			});
		this.CalcTotals();
	}


	/**
	 * Build up cellValues 2-D array
	 * Setup initial selected above/below line payees & income groups
	 **/
	SetupGrid() {
		//initialize 2-d array
		_.forEach(this.$scope.incomeGroups, (incomeGroup) => {
			if (this.cellValues[incomeGroup.characteristicValueID] == null) {
				this.cellValues[incomeGroup.characteristicValueID] = {};
				_.forEach(this.$scope.payees, (payee) => {
					this.cellValues[incomeGroup.characteristicValueID][payee.recordID] = 0;
					this.cellValues[incomeGroup.characteristicValueID]['' + 1 + payee.recordID] = 0;
				});
			}
		});

		// assign each split to a 2-D array cell
		_.forEach(this.$scope.royaltySplits, (split) => {
			var payeeKey = split.aboveTheLine ? "" + 1 + split.payeeID : split.payeeID; //concatenate 1 to front of recordID to denote above the line mvca-3283
			if (this.cellValues[split.incomeGroupID] == null) {
				this.cellValues[split.incomeGroupID] = {};
			}
			if (isNaN(this.cellValues[split.incomeGroupID][payeeKey]) || this.cellValues[split.incomeGroupID][payeeKey] == 0) {
				this.cellValues[split.incomeGroupID][payeeKey] = split.splitPercentage;
			}
			else {
				this.cellValues[split.incomeGroupID][payeeKey] = parseFloat(split.splitPercentage.toString())
			}
		});

		// Get unique above/below line payees from split collection
		var uniqueAboveLinePayeeIDs = _(this.$scope.royaltySplits).filter((split) => split.aboveTheLine).map((split) => split.payeeID).uniq().value();
		var uniqueBelowLinePayeeIDs = _(this.$scope.royaltySplits).filter((split) => !split.aboveTheLine).map((split) => split.payeeID).uniq().value();

		// get unique income group ids from split collection
		var uniqueIncomeGroupIDs = _(this.$scope.royaltySplits).map((split) => split.incomeGroupID).uniq().value();

		// set selected above/below line payees & income groups
		this.selectedAboveLinePayees = _(this.$scope.payees).filter((payee) => _.contains(uniqueAboveLinePayeeIDs, payee.recordID)).value();
		this.selectedBelowLinePayees = _(this.$scope.payees).filter((payee) => _.contains(uniqueBelowLinePayeeIDs, payee.recordID)).value();
		this.selectedIncomeGroups = _(this.$scope.incomeGroups).filter((incomeGroup) => _.contains(uniqueIncomeGroupIDs, incomeGroup.characteristicValueID)).value();
	}


	/**
	 * Precalculate cell totals for view
	 **/
	CalcTotals() {
		this.cellTotals = [];

		_.forEach(this.selectedIncomeGroups, (incomeGroup) => {

			var total = 0;
			_.forEach(this.selectedAboveLinePayees, (payee) => {
				//concatenate 1 to front of recordID to denote above the line mvca-3283
				total += parseFloat(<any>this.cellValues[incomeGroup.characteristicValueID]["" + 1 + payee.recordID]) || 0;
			});
			_.forEach(this.selectedBelowLinePayees, (payee) => {
				total += parseFloat(<any>this.cellValues[incomeGroup.characteristicValueID][payee.recordID]) || 0;
			});

			this.cellTotals[incomeGroup.characteristicValueID] = parseFloat(total.toFixed(8));
		});
	}

	/**
	 * Reacts to user changes in cellValues, translates back to IRoyaltySplit for the parent scope
	 **/
	UpdateSplits() {

		var newSplits: Models.IRoyaltySplit[] = [];

		var processCell = (group: Models.ICharacteristicMetaDataValue, aboveLine: boolean) => {
			return (payee: Models.IEntity) => {
				var payeeKey = aboveLine ? "" + 1 + payee.recordID : payee.recordID; //concatenate 1 to front of recordID to denote above the line
				var split: Models.IRoyaltySplit = {
					aboveTheLine: aboveLine,
					incomeGroupID: group.characteristicValueID,
					incomeGroupName: group.characteristicValueLabel,
					payeeID: payee.recordID,
					payeeName: payee.title,
					splitPercentage: this.cellValues[group.characteristicValueID][payeeKey] || 0,
					usageID: 0
				};
				if (split.splitPercentage > 0 && split.splitPercentage <= 100) {
					newSplits.push(split);
				}
			};
		};

		_.forEach(this.selectedIncomeGroups, (group) => {
			_.forEach(this.selectedAboveLinePayees, processCell(group, true));
			_.forEach(this.selectedBelowLinePayees, processCell(group, false));
		});

		this.$scope.royaltySplits = newSplits;
	}

	ColCount(collection: any[]) {
		if (collection == null) {
			return 1;
		} else {
			return (Math.ceil(collection.length / 10));
		}
	}
}

/**
 * Validation on a royalty total cell to always equal 100
 **/
export function RLCellTotalValidator() {
	var directive: ng.IDirective = {
		restrict: "A",
		require: "ngModel",
		link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, modelCtrl: ng.INgModelController) => {
			modelCtrl.$name = "incomeGroup" + attributes["rlCellTotalValidator"];
			modelCtrl.$validators["not100"] = (value) => {
				const parsed = parseFloat(value);
				return parsed > 0 && parsed <= 100;
			};
		}
	};
	return directive;
}

/**
 * validation for cell values
 **/
export function RLCellValidator() {
	var directive: ng.IDirective = {
		restrict: "A",
		require: "ngModel",
		link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, modelCtrl: ng.INgModelController) => {

			// get rid of non-numerics, allow for 1 decimal point
			var cleanNumber = (value: string) => {
				var tmp = value.replace(/\./, "|"); // save first decimal point as a |
				tmp = tmp.replace(/[^\d\|]/g, "");  // remove all non-numerics or |
				tmp = tmp.replace(/\|/, ".");       // turn saved | back to decimal point
				return tmp;
			};

			modelCtrl.$parsers.unshift((value) => {
				var cleaned = cleanNumber(value.toString());
				if (value != cleaned) {
					modelCtrl.$setViewValue(cleaned);
					modelCtrl.$render();
					return parseFloat(cleaned);
				}

				return parseFloat(value);
			});

			modelCtrl.$formatters.unshift((value) => {
				return parseFloat((value || "").toString().replace(/[^\d\.]/g, ""));
			});
		}
	};
	return directive;
}
